import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { tagPrefixCls } from "@/base/components/tag/Tag.component";
import { THEME_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Tag">> = ({
  fontSizeIcon,
  defaultColor,
  defaultColorWarning,
  defaultColorError,
  defaultColorSuccess,
  defaultColorProcessing,
}: any) => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${tagPrefixCls}`]: {
      lineHeight: `22px`,
      minWidth: `24px`,
      minHeight: `24px`,

      [`.${tagPrefixCls}-close-icon`]: {
        marginInlineStart: 8,
        fontSize: `${fontSizeIcon}px`,
      },

      [`&.${tagPrefixCls}-warning`]: {
        color: `${defaultColor}`,
        backgroundColor: defaultColorWarning,
        borderColor: defaultColorWarning,
      },

      [`&.${tagPrefixCls}-error`]: {
        color: `${defaultColor}`,
        backgroundColor: defaultColorError,
        borderColor: defaultColorError,
      },

      [`&.${tagPrefixCls}-success`]: {
        color: `${defaultColor}`,
        backgroundColor: defaultColorSuccess,
        borderColor: defaultColorSuccess,
      },

      [`&.${tagPrefixCls}-processing`]: {
        color: `${defaultColor}`,
        backgroundColor: defaultColorProcessing,
        borderColor: defaultColorProcessing,
      },
    },
  },
});

export const useTagStyle = genComponentStyleHook(["Tag", "cso"], (token) => {
  return [genStyle(token)];
});
